import { Image } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import legendItems from '../../constants/legend-items';
import createMarkerIcon from '../../utils/createMarkerIcon';
import styles from './Legend.module.css';

const cx = classnames.bind(styles);

export default function Legend() {
  const { t } = useTranslation(['feature', 'station']);

  return (
    <div className={cx('legend')}>
      {legendItems.map(({ color, labelKey }) => (
        <div key={color} className={cx('legendItem')}>
          <Image
            alt={t('markerIconAlt', { ns: 'feature' })}
            className={cx('legendItemIcon')}
            src={createMarkerIcon(color)}
          />
          &nbsp;
          {labelKey === 'hasNoPower'
            ? t(labelKey, { ns: 'station' })
            : t(labelKey, { ns: 'feature' })
          }
        </div>
      ))}
    </div>
  );
}
